import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Invoice } from '../../../models/invoices/invoice';
import { StorageService } from '../../../core/storage/storageService';
import { IconType } from '../../../../../../../libs/Shared/components/icon/icon';

@Component({
  selector: 'app-invoice-header',
  templateUrl: './invoice-header.component.html',
  standalone: false,
})
export class InvoiceHeaderComponent {
  IconType = IconType;

  @Input() iconType: any | undefined = undefined;
  @Input() text: string | undefined = undefined;
  @Input() invoice: Invoice | undefined = undefined;
  @Input() canCreateInvoices: boolean = false;
  @Input() canEditInvoices: boolean = false;
  @Output() createInvoiceClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output() editInvoiceClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output() invoiceSettingsClicked: EventEmitter<void> =
    new EventEmitter<void>();

  locationName: string | undefined = undefined;

  constructor(private storage: StorageService) {
    this.locationName = this.storage.getSelectedLocation()?.DBA || '';
  }
}
